import React, { useState, useRef, useEffect, useCallback } from 'react'
import axios from 'axios'
import "react-image-gallery/styles/css/image-gallery.css";
import ImageGallery from 'react-image-gallery';
import useInterval from '@use-it/interval'



export default function PhotoGallery({photoAlbumId, ...props}) {

  //console.log("rendering photo gallery", props)

  const [storedPhotos, setStoredPhotos] = useState([])
  const [querying, setQuerying] = useState(false)
  const [errorMessage, setErrorMessage] = useState(null)

  const [lastFetch, setLastFetch] = useState(null)

  const fetchPhotos = () => {
    console.log("Fetching fotos")
    axios.get("/api/mobiles/v1/stored_photos.json?order=desc&after=" + String(lastFetch) + "&limit=" + (props.limit ? props.limit : 300) + "&identifier=" + (props.identifier ? props.identifier : "") ).then(response => {
      console.log(response.data)
      setQuerying(false)
      if(response.status == 200) {
        setLastFetch(new Date().getTime() / 1000)

        const newPhotos = response.data.photos.map(photo => {
          return {
            original: photo.photo.urls.xl,
            thumbnail: photo.photo.urls.md
          }
        })
        console.log({newPhotos})
        setStoredPhotos(newPhotos)
      } else {
        setErrorMessage(response.data)
      }
    })
  }

  useEffect(fetchPhotos, [])
  useInterval(fetchPhotos, (props.refresh ? props.refresh : 15 * 1000))

  //const photos = storedPhotos.map((photo))
  if(querying) {
    return <i className="fa fa-spinner fa-spin"/>
  }
  if(errorMessage) {
    return <div className="alert alert-danger">{String(errorMessage)}</div>
  }

  return <ImageGallery items={storedPhotos} {...props}/>;
}